var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.customClass }, [
    _vm.formatValue == true
      ? _c("i", { staticClass: "mdi mdi-check text-success" })
      : _vm._e(),
    _vm._v(" "),
    _vm.formatValue == false
      ? _c("i", { staticClass: "mdi mdi-close text-primary" })
      : _vm._e(),
    _vm._v(" "),
    _vm.formatValue == null
      ? _c("i", {
          staticClass: "mdi mdi-checkbox-blank-circle-outline text-dark",
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }